import { BrandMark, useSiteBrand } from "./brand";
import { MapPinIcon, PhoneIcon, MailIcon } from "./icons";
import { formatMzPhone } from "./utils";

export const PublicFooter = ({ info, social = {}, onNav, sections = {} }) => {
  const brand = useSiteBrand();
  const socialLinks = [
    { key: "facebook", label: "Facebook", href: social.facebook },
    { key: "instagram", label: "Instagram", href: social.instagram },
    { key: "youtube", label: "YouTube", href: social.youtube },
  ].filter((s) => s.href && String(s.href).trim());

  return (
    <footer className="public-footer mt-8 border-t border-slate-200 dark:border-slate-700/80 bg-slate-950 text-slate-300 dark:text-slate-600">
      <div className="max-w-6xl mx-auto px-4 py-10 sm:px-6 lg:px-8">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-[1.35fr_.8fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <BrandMark brand={brand} className="h-11 w-11 shrink-0 rounded-2xl" />
              <div>
                <div className="font-extrabold text-white">{info.churchName}</div>
                <div className="text-xs text-slate-400 dark:text-slate-500">Uma família em Cristo, servindo com amor.</div>
              </div>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400 dark:text-slate-500">
              {brand.isDefault
                ? "Um lugar para crescer na fé, viver em comunhão e servir a comunidade em Maputo."
                : "Um lugar para crescer na fé, viver em comunhão e servir a comunidade."}
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              {socialLinks.map((s) => (
                <a key={s.key} href={s.href} target="_blank" rel="noreferrer" className="rounded-full border border-white dark:border-slate-900/15 px-3 py-1.5 text-xs font-bold text-slate-200 dark:text-slate-700 hover:border-indigo-300 dark:hover:border-indigo-700 hover:text-white transition">
                  {s.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="text-sm font-extrabold uppercase tracking-[0.14em] text-white">Explorar</div>
            <nav className="mt-4 grid gap-2 text-sm">
              {[
                ["Início", "#topo"],
                ...(sections.about ? [["Quem somos", "#sobre"]] : []),
                ["Agenda de cultos", "#cultos"],
                ...(sections.leadership ? [["Liderança", "#lideranca"]] : []),
                ...(sections.announcements ? [["Anúncios", "#anuncios"]] : []),
                ...(sections.gallery ? [["Galeria", "#galeria"]] : []),
                ...(sections.ministries ? [["Como servimos", "#ministerios"]] : []),
                ...(sections.birthdays ? [["Aniversários", "#aniversarios"]] : []),
                ["Contactos", "#contactos"],
              ].map(([label, href]) => (
                <a
                  key={href}
                  href={href}
                  onClick={(event) => {
                    event.preventDefault();
                    onNav?.(href);
                  }}
                  className="text-slate-400 dark:text-slate-500 hover:text-white transition"
                >
                  {label} <span aria-hidden="true">→</span>
                </a>
              ))}
            </nav>
          </div>

          <div>
            <div className="text-sm font-extrabold uppercase tracking-[0.14em] text-white">Fale connosco</div>
            <div className="mt-4 grid gap-3 text-sm">
              <div className="flex items-start gap-2"><MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-indigo-300" /><span>{info.contacts?.address || "Endereço a confirmar"}</span></div>
              {info.contacts?.phone ? <a href={`tel:${info.contacts.phone}`} className="flex items-center gap-2 text-slate-300 dark:text-slate-600 hover:text-white"><PhoneIcon className="h-4 w-4 shrink-0 text-indigo-300" />{formatMzPhone(info.contacts.phone)}</a> : null}
              {info.contacts?.email ? <a href={`mailto:${info.contacts.email}`} className="flex items-center gap-2 break-all text-slate-300 dark:text-slate-600 hover:text-white"><MailIcon className="h-4 w-4 shrink-0 text-indigo-300" />{info.contacts.email}</a> : null}
              <a href="#localizacao" className="mt-1 inline-flex w-fit rounded-full bg-white dark:bg-slate-900 px-3.5 py-2 font-bold text-slate-950 dark:text-slate-50 hover:bg-indigo-50 dark:hover:bg-indigo-950/40 transition">Como chegar</a>
            </div>
          </div>
        </div>
        <div className="mt-9 flex flex-col gap-2 border-t border-white/10 pt-5 text-xs text-slate-500 dark:text-slate-400 sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} {info.churchName}. Todos os direitos reservados.</span>
          <span>{brand.isDefault ? "Conteúdo da comunidade · Maputo, Moçambique" : "Conteúdo da comunidade"}</span>
        </div>
      </div>
    </footer>
  );
};
